"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createReducer;

/**
 * A very simple helper function to create reducers.
 *
 * the redux docs even suggest making this:
 * https://redux.js.org/recipes/reducingboilerplate#generating-reducers
 *
 * @template {{ [key: string]: (state: State, action: any) => State }} T
 * @template S
 * @param {S} initialState
 * @param {T} actionHandlers
 */
function createReducer(initialState, actionHandlers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    if (!actionHandlers[action.type]) return state;
    return actionHandlers[action.type](state, action);
  };
}